import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// Apply saved theme immediately to prevent flash
// 토스 인앱: 라이트 모드 전용 (TOSS_GUIDE 비게임 규정)
const isToss = navigator.userAgent.includes("TossApp");
if (!isToss) {
  const saved = localStorage.getItem("steamdeal-theme");
  if (saved === "dark" || (!saved && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
    document.documentElement.classList.add("dark");
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
